module.exports = __webpack_public_path__ + "static/media/slider-home-landing-slide-01-bg.31176ec1.jpg";